import { gql } from '@apollo/client';

// Подписка на изменение статуса любого пользователя
export const ALL_USERS_ONLINE_STATUS_SUBSCRIPTION = gql`
  subscription OnAllUsersOnlineStatusChanged {
    allUsersOnlineStatusChanged {
      userId
      isOnline
    }
  }
`;

// Подписка на изменение статуса текущего пользователя (для Ping-менеджера)
export const USER_ONLINE_STATUS_SUBSCRIPTION = gql`
  subscription OnUserOnlineStatusChanged($userId: ID!) {
    userOnlineStatusChanged(userId: $userId) {
      userId
      isOnline
    }
  }
`;